var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","right":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g(_vm._b({class:_vm.className},'v-btn',_vm.$attrs,false),Object.assign({}, on, _vm.$listeners)),[_vm._t("default")],2)]}}],null,true)},[_vm._t("tooltip")],2)}
var staticRenderFns = []

export { render, staticRenderFns }